import { clamp, rotatedSize, DEFAULT_CARD_SHADOW, getShadowColor } from "./ShareCardLayout";

export const DEFAULT_TEXT_SHADOW = {
  enabled: true, color: "#000000", opacity: 0.74, blur: 20, offsetX: 0, offsetY: 6,
};
export const DEFAULT_IMAGE_SHADOW = { ...DEFAULT_CARD_SHADOW, enabled: false };

const elementId = (kind) => `${kind}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const createTextElement = (scene, index, topZ) => ({
  id: elementId("text"), kind: "text", label: `Text ${index}`, text: "Your text",
  x: scene.width * 0.5, y: scene.height * 0.22, rotation: 0,
  fontSize: Math.round(scene.width * 0.045), color: "#ffffff", z: topZ + 1,
  shadow: { ...DEFAULT_TEXT_SHADOW },
});

export const createImageElement = (scene, upload, topZ, index = 0) => {
  const width = Math.min(scene.width * 0.32, scene.height * 0.4 * upload.width / upload.height);
  return constrainImageElement({
    id: elementId("image"), kind: "image", label: upload.name || "Image", src: upload.src,
    x: scene.width * (0.5 + (index % 4) * 0.025), y: scene.height * (0.5 + (index % 4) * 0.025),
    width, height: width * upload.height / upload.width, baseWidth: width,
    rotation: 0, z: topZ + 1, shadow: { ...DEFAULT_IMAGE_SHADOW },
  }, scene);
};

export const constrainImageElement = (element, scene) => {
  const size = rotatedSize(element.width, element.height, element.rotation);
  const factor = Math.min(1, scene.width / size.width, scene.height / size.height);
  const halfWidth = size.width * factor / 2;
  const halfHeight = size.height * factor / 2;
  return {
    ...element, width: element.width * factor, height: element.height * factor,
    x: clamp(element.x, halfWidth, scene.width - halfWidth),
    y: clamp(element.y, halfHeight, scene.height - halfHeight),
  };
};

export const getElementShadow = (element) => ({
  ...(element.kind === "text" ? DEFAULT_TEXT_SHADOW : DEFAULT_IMAGE_SHADOW), ...element.shadow,
});

export const getTextShadow = (element, pixelRatio = 1) => {
  const shadow = getElementShadow(element);
  if (!shadow.enabled || shadow.opacity <= 0) return "none";
  return `${shadow.offsetX * pixelRatio}px ${shadow.offsetY * pixelRatio}px ${shadow.blur * pixelRatio}px ${getShadowColor(shadow)}`;
};

export const readImageUpload = async (file) => {
  if (file.type && !file.type.startsWith("image/")) throw new Error(`“${file.name}” is not an image.`);
  const src = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error(`Could not read “${file.name}”.`));
    reader.readAsDataURL(file);
  });
  const image = await new Promise((resolve, reject) => {
    const next = new Image();
    next.onload = () => resolve(next);
    next.onerror = () => reject(new Error(`Could not open “${file.name}”. Choose a browser-supported image, such as PNG, JPEG, or WebP.`));
    next.src = src;
  });
  if (!image.naturalWidth || !image.naturalHeight) throw new Error(`“${file.name}” has no usable image dimensions.`);
  return { src, name: file.name, width: image.naturalWidth, height: image.naturalHeight };
};
